<template>
  <ul class="nav nav-tabs profile-tab" role="tablist">
    <li class="nav-item">
      <router-link
        :to="{ name: 'setting' }"
        class="nav-link"
        :class="{ active: activeMenu == 'setting' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
        v-if="!['producer', 'packer'].includes(currentRole)"
      >
        Setting
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'autoPayment' }"
        class="nav-link"
        :class="{ active: activeMenu == 'autoPayment' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
        v-if="!['producer', 'packer'].includes(currentRole)"
      >
        Autopayment
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'profile' }"
        class="nav-link"
        :class="{ active: activeMenu == 'profile' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
      >
        {{ $t('Update Password') }}
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'invoiceInfo' }"
        class="nav-link"
        :class="{ active: activeMenu === 'invoiceInfo' }"
        data-toggle="tab"
        role="tab"
        aria-selected="true"
        v-if="!['producer', 'packer'].includes(currentRole)"
      >
        Invoice Info
      </router-link>
    </li>
<!--    <li class="nav-item">-->
<!--      <router-link-->
<!--        :to="{ name: 'defaultPrice' }"-->
<!--        class="nav-link"-->
<!--        :class="{ active: activeMenu == 'defaultPrice' }"-->
<!--        data-toggle="tab"-->
<!--        role="tab"-->
<!--        aria-selected="true"-->
<!--      >-->
<!--        Default price-->
<!--      </router-link>-->
<!--    </li>-->
  </ul>
</template>


<script>
import ToastMixin from "@/mixins/ToastMixin";
import PageMixin from "@/mixins/PageMixin";

export default {
  name: "ProfileHeader",
  mixins: [PageMixin, ToastMixin],
  props: [
    'activeMenu'
  ],
};
</script>
